import { PerspectiveLessIcon } from './PerspectiveLessIcon';

/**
 * author: Michael Irigoyen
 * id 408FA22D-2054-4579-A991-DF061CDE5A00
 * name perspective-less
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/perspective-less.svg
 * tags
 * - Math 
 */
export const PerspectiveDecreaseIcon = PerspectiveLessIcon;
export default PerspectiveDecreaseIcon